import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Button, Typography } from "@mui/material";

import { useDialog } from "../../../common/components/dialog/useDialog";
import AddStreamDialog from "./AddStreamDialog";

const AddStreamDialogContainer = (): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">Add Stream</Typography>
      </Button>
      <AddStreamDialog open={open} onClose={handleDialogClose} />
    </>
  );
};

export default AddStreamDialogContainer;
